import axios from "axios";
import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import '../styles/global.css';
import menudots from '../assets/menu-dots.svg';
import menu from '../assets/menu.png';
import MenuIcon from '@mui/icons-material/Menu';


function MenuAssociados() {
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    const [menuAberto, setMenuAberto] = useState(false);
    const navigate = useNavigate();
    const menuRefA = useRef(null);
    
    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };
    const toggleLogoff = () => {
        localStorage.clear();
        localStorage.setItem('loggedIn', false);
        localStorage.removeItem('user');
        sessionStorage.clear();
        
        navigate('/');
        window.location.reload();
    };

    useEffect(() => {
        function handleClickOutside(event) {
          if (menuRefA.current && !menuRefA.current.contains(event.target)) {
            setMenuAberto(false);
          }
        }
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [menuRefA]);

    useEffect(() => {
        if (associado !== 1) {
            navigate('/Login');
            window.location.reload();
        }
    }, [associado, navigate]);

    useEffect(() => {
        const handleResize = () => {
          if (window.innerWidth > 768) {
            setMenuAberto(false);
          }
        };
    
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    //verifica se o usuário está logado e redireciona para o login se não estiver
    useEffect(() => {
        const loggedIn = sessionStorage.getItem('loggedIn');
        if (loggedIn === false || loggedIn === null || loggedIn === undefined) {
          navigate('/Login');
          window.location.reload();
        }
      }, [navigate]);

    //atualiza avisos não lidos na sessionStorage
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const dados = {
            "IdPessoa": sessionStorage.getItem('IdPessoa')
        };
        axios
        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterAvisosNaoLidos',
            dados,
            {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
                }
        )
        .then(response => {
            // console.log(response.data);
            if (response.data) {
                if(response.data.message)
                {
                    sessionStorage.setItem('avisosNaoLidos', 0);
                }
                else{
                    sessionStorage.setItem('avisosNaoLidos', response.data.length);
                }
            } else {
                sessionStorage.setItem('avisosNaoLidos', 0);
            }       
      });
    }, []);
    //atualiza votações com status ANDAMENTO na sessionStorage
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        
        axios
        .get(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemVotacoes',
            {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data);
            if (response.data) {
                //console.log(response.data);
                if(response.data.message)
                {
                    sessionStorage.setItem('votacoesAndamento', 0);
                }
                else{
                    //contar do response.data quantos registros estão com vtcPosicao igual a "ANDAMENTO"
                    const votacoesAndamento = response.data.filter(votacao => votacao.vtcPosicao === "ANDAMENTO").length;
                    sessionStorage.setItem('votacoesAndamento', votacoesAndamento);
                    
                }
            } else {
                sessionStorage.setItem('votacoesAndamento', 0);
            }       
      });
    }, []);
    //atualiza assembleis com status diferente de CANCELADO ou ENCERRADO
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

        axios
        .get(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterAssembleias',
            {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data);
            if (response.data) {
                if(response.data.message)
                {
                    sessionStorage.setItem('assembleiasAtivas', 0);
                }
                else{
                    //contar do response.data quantos registros estão com asPosicao diferente de "CANCELADO" ou "ENCERRADO"
                    const assembleiasAtivas = response.data.filter(assembleia => assembleia.assPosicao !== "CANCELADO" && assembleia.assPosicao !== "ENCERRADO").length;
                    sessionStorage.setItem('assembleiasAtivas', assembleiasAtivas);
                }
            } else {
                sessionStorage.setItem('assembleiasAtivas', 0);
            }       
      });
    }, []);

    return (
        <div>
            {/* <nav className="d-flex nav-linksAssoc"> */}
            <nav className="navbarAssoc">
                <div style={{ display: 'flex', marginLeft: '10px' }}>
                    <button className="menu-toggle" onClick={toggleMenu} style={{ backgroundColor: 'transparent', border: 'none', padding: 5 }}>
                        {/* <img src={menu} alt="Menu" className="menuIcon" /> */}
                        <MenuIcon style={{ color: '#fff', width: '48px', height: '48px', float: 'right' }} />
                    </button>
                </div>
                {/* <div className="d-flex flex-wrap mt1 clrWhite align-items-center fs10"> */}
                <div className={`nav-linksAssoc ${menuAberto ? 'aberto' : 'flex-wrap text-align-center fs10'}`} ref={menuRefA}>
                
                    {associado === 1 ? (
                        <Link to="/AreaDoAssociado" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>ÁREA DO ASSOCIADO <label className="labelMenuMenor">(Acompanhe suas contribuições)</label></Link>
                    ) : ('')}

                    {associado === 1 ? (
                        <Link to="/Assembleias" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>ASSEMBLEIAS <span className="fs10 pb3 clrRed">({sessionStorage.getItem('assembleiasAtivas')})</span><label className="labelMenuMenor">(Participe das assembleias)</label></Link>
                    ) : ('')}

                    {associado === 1 ? (
                        <Link to="/Votacoes" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>VOTAÇÕES <span className="fs10 pb3 clrRed">({sessionStorage.getItem('votacoesAndamento')})</span><label className="labelMenuMenor">(Participe das votações)</label></Link>
                    ) : ('')}

                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <Link to="/Agendas" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>AGENDAS <label className="labelMenuMenor">(Eventos, Encontros e Rolês)</label></Link>
                    ) : ('')}
                    {associado === 1 ? (
                        <Link to="/Avisos" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>AVISOS <span className="fs10 pb3 clrRed">({sessionStorage.getItem('avisosNaoLidos')})</span><label className="labelMenuMenor">(Confira os avisos importantes)</label></Link>
                    ) : ('')}
                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <Link to="/Associados" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>ASSOCIADOS<label className="labelMenuMenor">(Lista de Associados)</label></Link>
                    ) : ('')}

                    {associado === 1 ? (
                        <Link to="/Documentos" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>DOCUMENTOS<label className="labelMenuMenor">(Acesse documentos oficiais)</label></Link>
                    ) : ('')}

                    {associado === 1 ? (
                        <Link to="/Prestacoes" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>FINANCEIRO<label className="labelMenuMenor">(Acompanhe a prestação de contas)</label></Link>
                    ) : ('')}

                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <Link to="/Mensalidades" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>MENSALIDADES<label className="labelMenuMenor">(Gerencie as mensalidades)</label></Link>
                    ) : ('')}
                    
                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <Link to="/Contatos" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>CONTATOS<label className="labelMenuMenor">(Gerencie os contatos)</label></Link>
                    ) : ('')}

                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <Link to="/ModelosEmails" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>MODELO DE EMAIL<label className="labelMenuMenor">(Gerencie os modelos de email)</label></Link>
                    ) : ('')}

                    {parseInt(sessionStorage.pesAdmin) === 1 ? (    
                        <Link to="/Logs" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>LOGS<label className="labelMenuMenor">(Acompanhe os logs de atividades)</label></Link>
                    ) : ('')}

                    {parseInt(sessionStorage.pesAdmin) === 1 ? (    
                        <Link to="/Produtos" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleMenu}>PRODUTOS<label className="labelMenuMenor">(Gerencie os produtos)</label></Link>
                    ) : ('')}

                    <Link to="/" style={{marginTop: '10px', fontWeight: 'bold'}} onClick={toggleLogoff}>SAIR</Link>

                </div>
                
            </nav>
        </div>
    )
}

export default MenuAssociados;